export default __webpack_public_path__ + "static/media/awaiting5F.2173dbbb.svg";